import React from 'react';
import { Navigate } from 'react-router-dom';
import { useShopAdminAuth } from '../../context/ShopAdminAuthContext';

/**
 * Gate a /shop-admin route by required permission.
 * - When loading: render nothing
 * - When unauthenticated: send to /shop-admin/login
 * - When missing perm: send back to /shop-admin (which itself role-redirects)
 */
export const ShopPermGuard = ({ perm, children }) => {
  const { staff, loading, hasPerm } = useShopAdminAuth();
  if (loading) return null;
  if (!staff) return <Navigate to="/shop-admin/login" replace />;
  if (perm && !hasPerm(perm)) return <Navigate to="/shop-admin" replace />;
  return children;
};
